<template>
    <div>
        <div class="modal right fade" id="categorySideBar">
            <div class="modal-dialog">
                <div class="d-flex align-content-center justify-content-end">
                    <button type="button" class="btn-close p-3" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-content border-0">
                    <div class="modal-body p-0">
                        <ul class="small__nav p-0">
                            <template v-for="(item , id) in menu" :key="id">
                                <li><a :href="item">{{ id }}</a></li>
                            </template>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        menu: Object,
    },
}
</script>

<style scoped>

</style>
